import { applyMiddleware, createStore } from 'redux'
import thunk from 'redux-thunk'

import {
  contextReducer,
  IContext,
  IStore,
} from 'aem-libs-react-ts/src/store/Store'
import {
  IRegInvestAmountResponse,
  IRegInvestSavingsResponse,
} from 'aem-libs-regular-investment/src/services/types'

import {
  IInputAmountValues,
  IInputSavingsValues,
  IStaticParams,
} from '../model'
import { CalcType } from '../model/enums'
import { amountReducer, appReducer, savingsReducer } from '../reducers'

export interface IAppData {
  calcType: CalcType
}

export interface ISavingsCalc {
  savingsInputs: IInputSavingsValues
  savingsResult: IRegInvestSavingsResponse
}

export interface IAmountCalc {
  amountInputs: IInputAmountValues
  hasExtraDeposit: boolean
  amountResult: IRegInvestAmountResponse
}

export interface IRegInvestStore extends IStore<{}, IStaticParams> {
  app: IAppData
  amount: IAmountCalc
  savings: ISavingsCalc
}

const combined = (state: IRegInvestStore, action: any): IRegInvestStore => {
  return {
    context: contextReducer(state.context, action),
    app: appReducer(state.app, action),
    amount: amountReducer(state.amount, action),
    savings: savingsReducer(state.savings, action),
  }
}

export const makeStore = (initData: IContext) => {
  const initState: IRegInvestStore = {
    context: initData,
    app: null as IAppData,
    amount: null as IAmountCalc,
    savings: null as ISavingsCalc,
  }
  return createStore(combined, initState, applyMiddleware(thunk))
}
